import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const RadioGroupRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const options = question.options || [];

  const handleChange = (optionValue: string) => {
    onChange(optionValue);
  };

  return (
    <div className="space-y-3">
      {options.map((option) => (
        <label
          key={option.value}
          className={`flex items-start p-4 border-2 rounded-lg cursor-pointer transition-all ${
            value === option.value
              ? 'border-blue-500 bg-blue-50'
              : error
              ? 'border-red-200 hover:border-red-300'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <input
            type="radio"
            name={question.id}
            value={option.value}
            checked={value === option.value}
            onChange={() => handleChange(option.value)}
            className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
          />
          <div className="ml-3 flex-1">
            <span className="block text-gray-900 font-medium">{option.label}</span>
          </div>
        </label>
      ))}
    </div>
  );
};

export default RadioGroupRenderer;
